<template>
  <ActionSecondary
    tag="button"
    :state="state"
    :type="type"
  >
    <slot />
  </ActionSecondary>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

import ActionSecondary from '../../actions/secondary/ActionSecondary.vue';
import { actionProps } from '../../actions/actionProps';
import { ActionState } from '../../actions/ActionState';
import { ButtonType } from '../ButtonType';

export default defineComponent({
  name: 'ButtonSecondary',
  components: {
    ActionSecondary,
  },
  props: {
    ...actionProps,
    state: {
      type: String as PropType<ActionState>,
      required: false,
      default: () => ActionState.Idle,
    },
    type: {
      type: String as PropType<ButtonType>,
      required: false,
      default: ButtonType.Button,
    },
  },
});
</script>
